var exports = {
  "tb": "UserProfileModal.module__noteTextarea___aE9OVD",
  "CR": "UserProfileModal.module__modalRoot___aE9OVD",
  "eF": "UserProfileModal.module__userInfo___aE9OVD",
  "hR": "UserProfileModal.module__userInfoHeader___aE9OVD",
  "hA": "UserProfileModal.module__userInfoHeaderDesktop___aE9OVD",
  "Rn": "UserProfileModal.module__userInfoContent___aE9OVD",
  "yn": "UserProfileModal.module__profileDataWarning___aE9OVD",
  "S7": "UserProfileModal.module__nameRow___aE9OVD",
  "nT": "UserProfileModal.module__userName___aE9OVD",
  "a1": "UserProfileModal.module__userTag___aE9OVD",
  "Fj": "UserProfileModal.module__usernameRow___aE9OVD",
  "hI": "UserProfileModal.module__pronouns___aE9OVD",
  "sM": "UserProfileModal.module__srOnly___aE9OVD",
  "Li": "UserProfileModal.module__customStatusText___aE9OVD",
  "Ef": "UserProfileModal.module__customStatusRow___aE9OVD",
  "_z": "UserProfileModal.module__tagBadgeRow___aE9OVD",
  "U3": "UserProfileModal.module__badgesWrapper___aE9OVD",
  "ZV": "UserProfileModal.module__userNoteEditor___aE9OVD",
  "xu": "UserProfileModal.module__noteLabel___aE9OVD",
  "_j": "UserProfileModal.module__noteTextareaBase___aE9OVD",
  "jd": "UserProfileModal.module__noteTextareaEditing___aE9OVD",
  "EN": "UserProfileModal.module__noteTextareaNotEditing___aE9OVD",
  "bs": "UserProfileModal.module__profileContent___aE9OVD",
  "EM": "UserProfileModal.module__profileContentHeader___aE9OVD",
  "cI": "UserProfileModal.module__bannerContainer___aE9OVD",
  "HG": "UserProfileModal.module__bannerMask___aE9OVD",
  "_e": "UserProfileModal.module__bannerImage___aE9OVD",
  "N1": "UserProfileModal.module__headerContainer___aE9OVD",
  "H": "UserProfileModal.module__avatarContainer___aE9OVD",
  "fc": "UserProfileModal.module__actionButtonsContainer___aE9OVD",
  "hQ": "UserProfileModal.module__contentContainer___aE9OVD",
  "sq": "UserProfileModal.module__profileContentWrapper___aE9OVD",
  "zL": "UserProfileModal.module__scrollerFullHeight___aE9OVD",
  "jT": "UserProfileModal.module__modalContainer___aE9OVD",
  "uu": "UserProfileModal.module__actionButtons___aE9OVD",
  "iA": "UserProfileModal.module__buttonIcon___aE9OVD",
  "ro": "UserProfileModal.module__menuIcon___aE9OVD",
  "WB": "UserProfileModal.module__avatarFocusRing___aE9OVD",
  "VS": "UserProfileModal.module__tabsWrapper___aE9OVD",
  "OT": "UserProfileModal.module__mutualFriendsList___aE9OVD",
  "Z8": "UserProfileModal.module__mutualSectionDivider___aE9OVD",
  "KF": "UserProfileModal.module__mutualFriendItem___aE9OVD",
  "vu": "UserProfileModal.module__active___aE9OVD",
  "Qd": "UserProfileModal.module__mutualItemIconFrame___aE9OVD",
  "D9": "UserProfileModal.module__mutualFriendInfo___aE9OVD",
  "eV": "UserProfileModal.module__mutualFriendName___aE9OVD",
  "zD": "UserProfileModal.module__mutualFriendUsername___aE9OVD",
  "p$": "UserProfileModal.module__emptyState___aE9OVD",
  "Ny": "UserProfileModal.module__mutualGuildIcon___aE9OVD",
  "me": "UserProfileModal.module__separator___aE9OVD",
  "AI": "UserProfileModal.module__emptyStateIcon___aE9OVD",
};

module.exports = exports;
